<template>
  <div>
    <Header />

    <header class="header2">
      <div class="WhatsApp">
        <a href="#"><img src="@/assets/images/HOME/WhatsApp-Logo-Icon@2x.png" alt=""></a>
      </div>
      <div class="container">
        <div class="header2-cont">
          <div class="hd2-cont-left">
            <div class="text-wrap">
              <h1>{{ $tc('who_we_are_page.who_page_h1') }}
              </h1>
              <p>{{ $tc('who_we_are_page.who_page_p') }}
              </p>
            </div>
          </div>
          <div class="hd2-cont-right">
            <div class="hd2-img">
              <img src="@/assets/images/WHO-WE-ARE/Grupo 1437@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="img-cards">
      <div class="container">
        <div class="img-cards-cont">
          <div class="img-c-row">

          <div class="sub">
            <div class="img-card-div">
              <div class="card-img-wrap ">
                <img src="@/assets/images/WHO-WE-ARE/Grupo 1332@2x.png" class="wr1" alt="">
              </div>
              <h3>{{ $tc('who_we_are_page.who_card1') }}
              </h3>
              <p>{{ $tc('who_we_are_page.who_card1_p') }}
              </p>
            </div>
            <div class="img-card-div">
              <div class="card-img-wrap wr2">
                <img src="@/assets/images/WHO-WE-ARE/Grupo 1003@2x.png" class="wr2" alt="">
              </div>
              <h3>{{ $tc('who_we_are_page.who_card2') }}
              </h3>
              <p>{{ $tc('who_we_are_page.who_card2_p') }}
              </p>
            </div>
          </div>

          <div class="sub">
            <div class="img-card-div">
              <div class="card-img-wrap wr3">
                <img src="@/assets/images/WHO-WE-ARE/Grupo 1030@2x.png" class="wr3" alt="">
              </div>
              <h3>{{ $tc('who_we_are_page.who_card3') }}</h3>
              <p>{{ $tc('who_we_are_page.who_card3_p') }}
              </p>
            </div>
            <div class="img-card-div">
              <div class="card-img-wrap wr4">
                <img src="@/assets/images/WHO-WE-ARE/Grupo 1331@2x.png" class="wr4" alt="">
              </div>
              <h3>{{ $tc('who_we_are_page.who_card4') }}</h3>
              <p>{{ $tc('who_we_are_page.who_card4_p') }}
              </p>
            </div>
          </div>

          </div>
        </div>
      </div>
    </section>

    <section class="about-us">
      <div class="team-cont">
          <div class="first-wrap">
             <div class="team-box">
            <div class="team-member">
              <div class="team-img">
                <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 16@2x.png" alt="">
              </div>
              <div class="team-name">
                <h3>GASTON KOLKER</h3>
                <p>Founder & CEO</p>
              </div>
            </div>
            <div class="team-member vi">
              <div class="team-name">
                <h3>MIGUEL KOLKER</h3>
                <p>Owner</p>
              </div>
              <div class="team-img">
                <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 17@2x.png" alt="">
              </div>
            </div>
          </div>
          <div class="team-box big">
            <div class="div">
              <h2>{{ $tc('who_we_are_page.box_big_h2') }}</h2>
              <p>{{ $tc('who_we_are_page.box_big_p_1') }}
              </p>
              <p>
                {{ $tc('who_we_are_page.box_big_p_2') }}
              </p>
            </div>
          </div>
          </div>
        <div class="team-box">
          <div class="team-member">
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 18@2x.png" alt="">
            </div>
            <div class="team-name">
              <h3>ROCKY CHOI</h3>
              <p>COO & CCO</p>
            </div>
          </div>
          <div class="team-member vi">
            <div class="team-name">
              <h3>MICHAEL GOLDFINE</h3>
              <p>CFO</p>
            </div>
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 20@2x.png" alt="">
            </div>
          </div>
        </div>
        <div class="team-box">
          <div class="team-member">
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 19@2x.png" alt="">
            </div>
            <div class="team-name">
              <h3>DAN ATTIE BETESH</h3>
              <p>General Manager</p>
            </div>
          </div>
          <div class="team-member vi">
            <div class="team-name">
              <h3>MARCELO RICCI</h3>
              <p>Managing Director - Argentina</p>
            </div>
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 21@2x.png" alt="">
            </div>
          </div>
        </div>
        <div class="team-box">
          <div class="team-member">
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 22@2x.png" alt="">
            </div>
            <div class="team-name">
              <h3>ASTRID JASNIS</h3>
              <p>Operations</p>
            </div>
          </div>
          <div class="team-member vi">
            <div class="team-name">
              <h3>CARLOS BURGO</h3>
              <p>VP TAX & M&M</p>
            </div>
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 24@2x.png" alt="">
            </div>
          </div>
        </div>
        <div class="team-box">
          <div class="team-member">
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 23@2x.png" alt="">
            </div>
            <div class="team-name">
              <h3>GERSON GONZALES</h3>
              <p>Compliance Operations</p>
            </div>
          </div>
          <div class="team-member vi">
            <div class="team-name">
              <h3>MICAELA MANIOTTI</h3>
              <p>CMO</p>
            </div>
            <div class="team-img">
              <img src="@/assets/images/WHO-WE-ARE/Enmascarar grupo 25@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactBox />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ContactBox from '@/components/ContactBox'

export default {
  name: 'WhoWeAre',

  components: {
    Header,
    Footer,
    ContactBox
  },

  created () {
    document.title = `Quiénes somos - ${process.env.VUE_APP_TITLE}`
  }
}
</script>
